import styles from "../BundleComp/bundleComp.module.scss";
import PopUp from "../common/ReactPortal/PortalPopUp";
import Srcset from "../common/Srcset";
import QuickBuyIcon from "../Logos/QuickBuy";
import { useState, useEffect } from "react";
import { bodyOverflow, makeId } from "@/helpers/userHelpers";
import BundleProductTile from "./BundleProductTile";

export default function BundleComponent({ productDetails }) {
    let bundleImage = productDetails.bundle_image?.reference?.image;
    let products = productDetails.bundle_products?.references?.edges;
    let mainProductImage = productDetails.featuredImage;
    //if (!products) {
        /* Exit. If not products found */
       // return null
    //}
    const [productsLength, setProductsLength] = useState(products.length);
    useEffect(() => {
        if(products && products.length) {
            let length = 0;

            products.map((p) => {
                if(p &&  p.node && p.node.availableForSale){
                    length++
                }
              });
              setProductsLength(length)
        }
    }, [products]);

    function add3Dots(string, limit) {
        var dots = "...";
        if (string.length > limit) {
            // you can also use substr instead of substring
            string = string.substring(0, limit) + dots;
        }

        return string;
    }

    return (
        <>
            {productsLength&& <div className={`${styles.wrapper} bundle_component row`}>
                <div className={`${styles.content} grid-md-7 grid-sm-6`}>
                    <h3 className={`d-xs-none heading-350`}>Get the look </h3>
                    
                    <div className={`${styles.product_list} ${products && productsLength > 3 ? styles.overflow_content : ''} grid-md-11 grid-sm-12`}>
                        {products && products.map((product,index) => {
                            product = product.node;
                            if (!product) {
                                console.error("Issue with product bundle object");
                                return null
                            }
                            /* Hide soldout products */
                            if(!product.availableForSale) {
                                return null
                            }
                            return (
                                <div key={index}>
                                    <BundleProductTile product={product} />
                                </div>
                            )
                        }
                        )}
                    </div>
                </div>
                <div className={`${styles.image_wrapper} ${products && productsLength < 3 ? styles.set_min_height : ''} grid-md-5 grid-sm-6 grid-xs-12`}>
                    {bundleImage ?
                        <Srcset src={bundleImage.src} /> :
                        <Srcset src={mainProductImage.src} alt={mainProductImage.alt} width={mainProductImage.width} height={mainProductImage.height} />}

                </div>
                <h3 className={`d-none d-xs-block mb-20`}>Get the look</h3>
            </div>
            }
        </>
    )
}